module.exports = __webpack_public_path__ + "static/media/scan-station.b7e675c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scan-station.png
// module id = 1276
// module chunks = 0